<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import Button from "../../shared/Button.svelte";
  import Modal from "../../shared/Modal.svelte";
  import EntryDetails from "./EntryDetails.svelte";
  import AddEntryForm from "./AddEntryForm.svelte";
  import { DatabaseName, ArticleType } from "../../stores/types";
  import type { Entry, DBInventoryEntry, Article, DBArticleEntry } from "../../stores/types";
  import Accordion from "../../shared/Accordion.svelte";
  import ArticleDetails from "../articles/ArticleDetails.svelte";
  let visible = true;
  let inventoryPromise = null;
  let inventory = [];
  let articleInInventory = [];
  let articles: DBArticleEntry[] = [];

  const artcleTypes = Object.entries(ArticleType);

  $: inventoryPromise = $userbaseStore.openDatabase({
    databaseName: DatabaseName.INVENTORY.toString(),
    changeHandler,
  });

  function changeHandler(items: [DBInventoryEntry]) {
    inventory = items;
    if (articleInInventory.length === 0) {
      inventory.forEach((element: DBInventoryEntry) => {
        articleInInventory.push(element.item.article.item.name);
      });
    }
    inventory.sort(sortInventory);
    console.log(inventory);
  }

  var sortInventory = function (a: DBInventoryEntry, b: DBInventoryEntry) {
    var nameA = a.item.article.item.name.toUpperCase();
    var nameB = b.item.article.item.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  };

  let showModal = false;
  const toggleModal = () => {
    showModal = !showModal;
  };

  const addIngredient = (e) => {
    showModal = false;
    visible = true;
  };
</script>

<Modal {showModal} on:click={toggleModal}>
  <AddEntryForm {articleInInventory} on:addIngredient={addIngredient} />
</Modal>
<div>
  <div class="add-ingredient">
    <Button type="secondary" on:click={toggleModal}>Neue Zutaten <span style="font-size:medium; color:white; margin-left: 10px;"><i class="fas fa-plus-circle" /></span></Button>
  </div>
  <div>
    {#each artcleTypes as entry}
      <Accordion title={entry[1]} {visible}>
        <div class="ingredient-list">
          {#each inventory as dbEntry}
            {#if dbEntry.item.article.item.type === entry[1]}
              <EntryDetails {dbEntry} itemId={dbEntry.itemId} />
            {/if}
          {/each}
        </div>
      </Accordion>
    {/each}
  </div>
</div>

<style>
  .add-ingredient {
    text-align: right;
  }
  .ingredient-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 20px;
  }
</style>
